import { Component, OnDestroy, OnInit } from '@angular/core';
import {HighlightService} from "../highlight.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-view-highlight',
  templateUrl: './view-highlight.component.html',
  styleUrls: ['./view-highlight.component.scss']
})
export class ViewHighlightComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  highligtData: any;
  narrative: string = '';
  highlightId!: string | null;
  constructor(private  highlightService : HighlightService,
              private mRouter: Router,
              private route : ActivatedRoute,) { }

  ngOnInit(): void {
    // Check if there is an ID in the route (edit mode)
    this.route.paramMap.pipe(takeUntil(this._destroyed$)).subscribe(params => {
      this.highlightId = params.get('id');
      if (this.highlightId) {
        this.getHighlights(this.highlightId);
      }
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  getHighlights(id:string){
    this.highlightService.getHighlightsById(id).pipe(takeUntil(this._destroyed$)).subscribe(data => {
      this.highligtData = data;
      console.log(this.highligtData)
    })
  }
  getJoinedHighlights(): string {
    if (!this.highligtData || !this.highligtData.highlights || !Array.isArray(this.highligtData.highlights)) {
      return 'No Highlights Available';
    }
    return this.highligtData.highlights.map((h:any) => h.highlight).join(', ');
  }

  cancel() {
    this.mRouter.navigateByUrl('home/reports/highlight');
  }
}
